import IMG_REWARD_COMPLETED from '../../../public/static/v4/event/icon-reward-completed.svg';
import PageImage from '../../common/component/PageImage';

interface IProps {
  isCompleted: boolean;
  isEmphasis: boolean;
  isBgPurple?: boolean;
  rewardImage?: string;
}

export default function RewardImageV4({
  isCompleted,
  isEmphasis,
  isBgPurple,
  rewardImage,
}: IProps) {
  const hasPadding = !isCompleted && isBgPurple;
  return (
    <div
      className={cn(
        FULL_SIZE_CN,
        hasPadding && {
          'p-15': isEmphasis,
          'p-8': !isEmphasis,
        }
      )}
      data-testid="reward-image"
    >
      <div
        className={cn('overflow-hidden rounded-50per', FULL_SIZE_CN, {
          'bg-purple': hasPadding,
        })}
        data-testid="reward-image-wrapper"
      >
        {isCompleted && (
          <img
            src={IMG_REWARD_COMPLETED}
            alt="Completed"
            className={FULL_SIZE_CN}
          />
        )}
        {!isCompleted && rewardImage && (
          <PageImage
            src={rewardImage}
            className={FULL_SIZE_CN}
            alt="Ticket reward"
          />
        )}
      </div>
    </div>
  );
}

const FULL_SIZE_CN = 'w-full h-full';
